import { render, staticRenderFns } from "./SettingsUserEditDelegationView.vue?vue&type=template&id=45fc4d31&scoped=true&"
import script from "./SettingsUserEditDelegationView.vue?vue&type=script&lang=js&"
export * from "./SettingsUserEditDelegationView.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "45fc4d31",
  null
  
)

/* vuetify-loader */
import installComponents from "!../../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VAutocomplete } from 'vuetify/lib/components/VAutocomplete';
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VCard } from 'vuetify/lib/components/VCard';
import { VCardActions } from 'vuetify/lib/components/VCard';
import { VCardText } from 'vuetify/lib/components/VCard';
import { VForm } from 'vuetify/lib/components/VForm';
import { VSelect } from 'vuetify/lib/components/VSelect';
import { VSpacer } from 'vuetify/lib/components/VGrid';
import { VTextField } from 'vuetify/lib/components/VTextField';
installComponents(component, {VAutocomplete,VBtn,VCard,VCardActions,VCardText,VForm,VSelect,VSpacer,VTextField})


/* hot reload */
if (module.hot) {
  var api = require("/srv/dev/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('45fc4d31')) {
      api.createRecord('45fc4d31', component.options)
    } else {
      api.reload('45fc4d31', component.options)
    }
    module.hot.accept("./SettingsUserEditDelegationView.vue?vue&type=template&id=45fc4d31&scoped=true&", function () {
      api.rerender('45fc4d31', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/settings/users/edit/SettingsUserEditDelegationView.vue"
export default component.exports